module.exports = __webpack_public_path__ + "img/6_151.9e971849.png";